import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingCategory} from './pricing-category';

@JsonObject('model.PricingPrice')
export class PricingPrice extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(String, 'description')
  description?: string

  @JsonProperty(Number, 'pricePerItem')
  pricePerItem?: number

  @JsonProperty(Number, 'pricePerItemDelivery')
  pricePerItemDelivery?: number

  @JsonProperty(Number, 'pricePerItemInstall')
  pricePerItemInstall?: number

  @JsonProperty(Number, 'pricePerLinFT')
  pricePerLinFT?: number

  @JsonProperty(Number, 'pricePerSQFT')
  pricePerSQFT?: number

  @JsonProperty(PricingCategory, 'pricingCategory')
  pricingCategory?: PricingCategory;
}

